import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { CreateRepSchema, Reps, reps } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormReps from '../forms/FormReps'

export default function AdicionarRep() {
    const { mutateAsync, isLoading } = reps.mutations.useCreate({
        invalidateQuery: true,
    })
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<Reps> = ({ ultimoNsr, ...data }) => {
        const payload = {
            ...data,
            ultimoNsr: ultimoNsr ? +ultimoNsr : null,
            empresaId,
            dataInicial: data.dataInicial
                ? dayjs(data.dataInicial).format('DD/MM/YYYY')
                : null,
        }

        return mutateAsync(payload, {
            onSuccess: () => {
                toast.success('Rep adicionado com sucesso!')
            },

            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateRepSchema}
            open={hasPermission(['create', 'Reps'])}
        >
            <Dialog.Title>Adicionar Rep</Dialog.Title>
            <Dialog.Content>
                <FormReps />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
